module.exports = __webpack_public_path__ + "media/featured_internships/penguin-logo-1b976058.gif";